export class PresentationConvertionModel {
  constructor (public fileId: string, public totalAmount: number) {}
}
